import React from "react"
import './index.scss'
import pJson from '../../../package.json'
import { useTranslation } from 'react-i18next';

const FooterOne = ({
    compact = false, orderCode 
}) => {
    const {
        t, i18n 
    } = useTranslation();

    const hsHref = `https://www.happysolutions.hu/?utm_source=orderPage${orderCode ? `&utm_id=${encodeURIComponent(orderCode)}` : ''}`;

    const selectLang = (lng) => {
        try {
            localStorage.setItem('i18nextLng', lng); 
        } catch(e) { /* ignore */ }
        i18n.changeLanguage(lng);
    };

    const flagBtn = {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: '50%',
        marginRight: 8,
        background: 'rgba(255,255,255,0.6)',
        border: '1px solid rgba(0,0,0,0.08)',
        cursor: 'pointer',
        boxShadow: '0 2px 6px rgba(0,0,0,0.08)'
    };

    if (compact) {
        return (
            <div className='footer footer-one' style={{
                height: 'auto',
                padding: '12px 0',
                borderTop: '1px solid #eee' 
            }}>
                <div className="footer-content" style={{ padding: 0 }}>
                    <div className="bottom" style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 12,
                        flexWrap: 'wrap' 
                    }}>
                        <a href={hsHref} target='_blank' rel="noreferrer" className='logo-container' style={{
                            display:'inline-flex',
                            alignItems:'center',
                            gap:8,
                            textDecoration:'none' 
                        }}>
                            <img
                                src={'https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/logo.png'}
                                alt={t('footer.brandAlt', 'Happy Solutions Logo')}
                                style={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: 4 
                                }}
                            />
                            <strong className='t-l'>{t('common.appName')}</strong>
                        </a>
                        <div className="footer-quick-links" style={{
                            display:'flex',
                            alignItems:'center',
                            gap:12 
                        }}>
                            <a href={`https://happysolutions.hu/aszf?utm_source=orderPage${orderCode ? `&utm_id=${encodeURIComponent(orderCode)}` : ''}`} target='_blank' rel="noreferrer">{t('footer.links.tos', 'Terms of use')}</a>
                            <a href={`https://happysolutions.hu/tos?utm_source=orderPage${orderCode ? `&utm_id=${encodeURIComponent(orderCode)}` : ''}`} target='_blank' rel="noreferrer">{t('footer.links.privacy', 'Data handling')}</a>
                            <a href="/about-us">
                                {t('footer.links.aboutUs', 'About us')}
                            </a>
                        </div>
                        <div style={{
                            display:'flex',
                            alignItems:'center',
                            gap:12 
                        }}>
                            <small>Copyright © 2020-{new Date().getFullYear()} Happy Gastro Kft.</small>
                            <small>v{pJson.version}</small>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='footer footer-one' style={{ height: '100%' }}>
            <div className="footer-content">
                <div className="top">
                    <div className="column column-1">
                        <a href={hsHref} target='_blank' rel="noreferrer" className='logo-container'>
                            <img
                                src={'https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/logo.png'}
                                alt={t('footer.brandAlt', 'Happy Solutions Logo')}
                                className='logo-img'
                            />
                            <h3 className='t-l'>
                                {t('common.appName')}
                            </h3>
                        </a>
                        <p>
                            {t('footer.description')}
                        </p>
                        <div className="links">
                            <a href="mailto:info@happygastro.hu" aria-label={t('footer.links.email', 'E-mail')} title={t('footer.links.email', 'E-mail')}>
                                <i className="bx bx-mail-send" aria-hidden="true"/>
                            </a>
                            <a href="tel:+3613009105" aria-label={t('footer.links.phone', 'Telefon')} title={t('footer.links.phone', 'Telefon')}>
                                <i className="bx bx-phone" aria-hidden="true"/>
                            </a>
                            <a href="https://www.facebook.com/gastro.happy" target='_blank' rel="noreferrer" aria-label="Facebook" title="Facebook">
                                <i className="bx bxl-facebook" aria-hidden="true"/>
                            </a>
                        </div>

                        <div className="aszf">
                            <a href="/aszf" target='_blank'>
                                {t('footer.links.tos')}
                            </a>
                        </div>
                        <div className="adatkezelesi-tajekoztato">
                            <a href="/adatkezelesi-tajekoztato" target='_blank'>
                                {t('footer.links.privacy')}
                            </a>
                        </div>
                        <div className="karrier">
                            <a href="/karrier" target='_blank'>
                                {t('footer.links.career')}
                            </a>
                        </div>
                        <div className="partner-program">
                            <a href="/partner-program" target='_blank'>
                                {t('footer.links.partnerProgram')}
                            </a>
                        </div>
                        <div className="gyik">
                            <a href="/kapcsolat/gyik" target='_blank'>
                                {t('footer.links.faq')}
                            </a>
                        </div>
                        <div className="integrations">
                            <a href="/integraciok" target='_blank'>
                                {t('footer.links.integrations')}
                            </a>
                        </div>
                        <div className="about-us">
                            <a href="/about-us" target='_blank'>
                                {t('footer.links.about', 'About us')}
                            </a>
                        </div>
                        <br/>
                    </div>
                    <div className="column column-2 footer-sitemap">
                        <h3>{t('nav.products', 'Megoldásaink')}</h3>
                        <div className="links">
                            <a href="/erp-vallalatiranyitasi-rendszer"><i className="bx bx-buildings"/> {t('nav.erp', 'Happy ERP')}</a>
                            <a href="/crm-rendszer"><i className="bx bx-user-voice"/> {t('nav.crm', 'Happy CRM')}</a>
                            <a href="/trade-kereskedelmi-rendszer"><i className="bx bx-store-alt"/> {t('nav.trade', 'Happy Trade')}</a>
                            <a href="/gastro-ettermi-szoftver"><i className="bx bx-restaurant"/> {t('nav.gastro', 'Happy Gastro')}</a>
                            <a href="/service-idopontfoglalo-app"><i className="bx bx-calendar-check"/> {t('nav.serviceApp', 'Happy Service App')}</a>
                            <a href="/logistic-app"><i className="bx bx-package"/> {t('nav.logisticApp', 'Happy Logistic App')}</a>
                        </div>
                    </div>
                    <div className="column column-3">
                        <h3>
                            {t('footer.contactsHeading')}
                        </h3>
                        <div className="links">
                            <a href="https://goo.gl/maps/T3hRZM87rtbpGRiY7" target={'_blank'} rel="noreferrer">
                                <i className="bx bx-map-pin"/>
                                <strong>
                                    Szentendre, Duna korzó 11, 2000
                                </strong>
                            </a>
                            <a href="tel:+3613009105">
                                <i className="bx bx-phone-call"/>
                                <strong>
                                    +36 (1) 300 9105
                                </strong>
                            </a>
                            <a href="mailto:info@happygastro.hu">
                                <i className="bx bx-info-circle"/>
                                <strong>
                                    info@happygastro.hu
                                </strong>
                            </a>
                            <a href="mailto:support@happygastro.hu">
                                <i className="bx bx-wrench"/>
                                <strong>
                                    support@happygastro.hu
                                </strong>
                            </a>
                        </div>
                        <div className="footer-lang" style={{ marginTop: 16 }}>
                            <div className="flags" style={{
                                display:'flex',
                                gap:8 
                            }}>
                                <button aria-label="Hungarian" title="Hungarian" style={flagBtn} onClick={()=>selectLang('hu')}>🇭🇺</button>
                                <button aria-label="English" title="English" style={flagBtn} onClick={()=>selectLang('en')}>🇬🇧</button>
                                <button aria-label="German" title="German" style={flagBtn} onClick={()=>selectLang('de')}>🇩🇪</button>
                            </div>
                            <div className="flag-label" style={{
                                marginTop:8,
                                fontSize:12,
                                opacity:0.8 
                            }}>
                                {t('footer.chooseLanguage', 'Choose language:')}
                            </div>
                        </div>
                    </div>
                    <div className="column column-4 footer-sitemap">
                        <h3>{t('nav.services', 'Szolgáltatásaink')}</h3>
                        <div className="links">
                            <a href="/foglalas"><i className="bx bx-calendar-event"/> {t('footer.links.booking', 'Foglalás / Konzultáció')}</a>
                            <a href="/integraciok"><i className="bx bx-plug"/> {t('footer.links.integrations', 'Integrációk')}</a>
                            <a href="/partner-program"><i className="bx bx-network-chart"/> {t('footer.links.partnerProgram', 'Partner program')}</a>
                            <a href="/karrier"><i className="bx bx-briefcase"/> {t('footer.links.career', 'Karrier')}</a>
                            <a href="/kapcsolat/gyik"><i className="bx bx-help-circle"/> {t('footer.links.faq', 'GYIK')}</a>
                            <a href="/kapcsolat/ugyfelszolgalat"><i className="bx bx-support"/> {t('nav.support', 'Kérjen ingyenes bemutatót!')}</a>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <strong>Copyright © 2020-{new Date().getFullYear()} Happy Gastro Kft. - {t('footer.rightsReserved')}</strong>
                    <div className='happy'>
                        <strong>
                            {t('footer.poweredByPre')}
                        </strong>
                        <a href={hsHref} target='_blank' rel="noreferrer" className="watermark">
                            <img src={'https://happy-releases.fra1.cdn.digitaloceanspaces.com/Uploads/logo.png'}
                                alt={t('footer.watermarkAlt', 'Happy Solutions')} />
                            <span>
                                {t('common.appName')}<sup style={{
                                    fontSize: '7px',
                                    color: '#f1b44c' 
                                }}>™</sup>
                            </span>
                        </a>
                        <strong>
                            {t('footer.poweredByPost')}
                        </strong>
                        <strong>
                            !
                        </strong>
                    </div>
                    <small>v{pJson.version}</small>
                </div>
            </div>
        </div>
    )
}

export default FooterOne;
